<template></template>
<script>
export default {
  name: "WaterMark",
  props: ["domName", "waterMaskText1", "waterMaskText2"],
  data() {
    return {
      watermarkTimer: null,
    };
  },
  mounted() {
    this.addWaterMask();
  },
  beforeDestroy() {
    // 清理定时器
    if (this.watermarkTimer) {
      clearInterval(this.watermarkTimer);
      this.watermarkTimer = null;
    }
    // 移除所有水印元素
    this.removeWaterMark();
  },
  methods: {
    // 移除水印元素
    removeWaterMark() {
      const parentDom = document.querySelector(this.domName);
      if (parentDom) {
        // 移除 #watermark 容器及其所有子元素
        const watermarkContainer = parentDom.querySelector("#watermark");
        if (watermarkContainer) {
          watermarkContainer.remove();
        }
        // 移除所有 .watermark-item 元素（防止有遗漏的）
        const watermarkItems = parentDom.querySelectorAll(".watermark-item");
        watermarkItems.forEach(item => item.remove());
      }
    },
    addWaterMask() {
      const { systemName } = this.$store.state.systemConfig,
        _this = this;

      const waterMaskText1 = this.waterMaskText1 || "";
      const waterMaskText2 = this.waterMaskText2 || "";
      //const systemNameText = systemName || this.$translate("appTitle");
      function watermark(element) {
        if (element.getElementsByTagName("div").length > 10) {
          return;
        }
        // 获取元素的坐标
        function getOffset(el) {
          if (el.offsetParent) {
            return {
              x: el.offsetLeft + getOffset(el.offsetParent).x,
              y: el.offsetTop + getOffset(el.offsetParent).y,
            };
          }
          return {
            x: el.offsetLeft,
            y: el.offsetTop,
          };
        }
        if (!element) return;
        // 默认配置
        const _config = {
          text1: waterMaskText1, //文本1
          text2: waterMaskText2, // 文本2
          start_x: 0, // x轴起始位置
          start_y: 0, // y轴起始位置
          space_x: 100, // x轴间距
          space_y: 50, // y轴间距
          width: 210, // 宽度
          height: 80, // 长度
          fontSize: 20, // 字体
          color: "#ccc", // 字色
          alpha: 0.6, // 透明度
          rotate: 15, // 倾斜度
        };
        // 替换默认配置
        if (arguments.length === 2 && typeof arguments[1] === "object") {
          const src = arguments[1] || {};
          for (let key in src) {
            if (src[key] && _config[key] && src[key] === _config[key]) {
              continue;
            } else if (src[key]) {
              _config[key] = src[key];
            }
          }
        }
        // 节点的总宽度
        const total_width = element.scrollWidth;
        // 节点的总高度
        const total_height = element.scrollHeight;
        // 创建文本碎片，用于包含所有的插入节点
        const mark = document.createDocumentFragment();
        // 水印节点的起始坐标
        const position = getOffset(element);
        let x = position.x + _config.start_x,
          y = position.y + _config.start_y;
        // 先循环y轴插入水印
        do {
          // 再循环x轴插入水印
          do {
            // 创建单个水印节点
            const item = document.createElement("div");
            item.className = "watermark-item";
            // 设置节点的样式
            item.style.position = "absolute";
            item.style.zIndex = 99999;
            item.style.left = `${x}px`;
            item.style.top = `${y}px`;
            item.style.width = `${_config.width}px`;
            item.style.height = `${_config.height}px`;
            item.style.fontSize = `${_config.fontSize}px`;
            item.style.color = _config.color;
            item.style.textAlign = "center";
            item.style.opacity = _config.alpha;
            item.style.paddingTop = "10px";
            item.style.filter = `alpha(opacity=${_config.alpha * 100})`;
            // item.style.filter = `opacity(${_config.alpha * 100}%)`;
            item.style.webkitTransform = `rotate(-${_config.rotate}deg)`;
            item.style.MozTransform = `rotate(-${_config.rotate}deg)`;
            item.style.msTransform = `rotate(-${_config.rotate}deg)`;
            item.style.OTransform = `rotate(-${_config.rotate}deg)`;
            item.style.transform = `rotate(-${_config.rotate}deg)`;
            item.style.pointerEvents = "none"; //让水印不遮挡页面的点击事件
            // 创建text1水印节点
            const text1 = document.createElement("div");
            text1.appendChild(document.createTextNode(_config.text1));
            text1.style.fontSize = `${_config.fontSize}px`;
            item.appendChild(text1);
            // 创建text2水印节点
            const text2 = document.createElement("div");
            text2.appendChild(document.createTextNode(_config.text2));
            text2.style.fontSize = `${_config.fontSize}px`;
            item.appendChild(text2);
  
            // const dateText = document.createElement("div");
            // dateText.appendChild(
            //   document.createTextNode(_this.$moment().format("YYYY-MM-DD hh:mm"))
            // );
            // dateText.style.fontSize = `${_config.fontSize}px`;
            // item.append(dateText);

            // 添加水印节点到文本碎片
            mark.appendChild(item);
            // x坐标递增
            x = x + _config.width + _config.space_x;
            // 超出文本右侧坐标停止插入
          } while (total_width + position.x > x + _config.width);
          // 重置x初始坐标
          x = position.x + _config.start_x;
          // y坐标递增
          y = y + _config.height + _config.space_y;
          // 超出文本底部坐标停止插入
        } while (total_height + position.y > y + _config.height);
        // 插入文档碎片
        element.appendChild(mark);
      }

      function watermark2() {
        let parentDom = document.querySelector(_this.domName);
        if (!parentDom) return;
        let d = null;
        if (parentDom) {
          d = parentDom.querySelector("#watermark");
        }
        if (d) {
          watermark(d);
        } else {
          let element = document.createElement("div");
          element.id = "watermark";
          element.style.position = "absolute";
          element.style.left = "0";
          element.style.right = "0";
          element.style.top = "0";
          element.style.bottom = "0";
          element.style.pointerEvents = "none";
          element.style.zIndex = "999";
          element.style.opacity = "0.5";
          parentDom.appendChild(element);
          watermark(element);
        }
      }
      clearInterval(this.watermarkTimer);
      this.watermarkTimer = setInterval(() => watermark2(), 2000);
    },
  },
};
</script>
